import { render, staticRenderFns } from "./ChangeStock.vue?vue&type=template&id=105d6701&"
import script from "./ChangeStock.vue?vue&type=script&lang=js&"
export * from "./ChangeStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports